import { createStyles, makeStyles } from '@material-ui/core';

import { PERSONALIZATION_TOKEN_TAG } from '@utils/personalization';
import { variables } from '@styles';

export const useStyles = makeStyles(() =>
  createStyles({
    inputContainer: {
      maxWidth: 'calc(100% - 10rem)',
      minWidth: '43.6rem',
      width: 'calc(100% - 10rem)',
    },
    fieldLabel: {
      lineHeight: '2.6rem',
      minWidth: '10rem', //'28.6rem', // '53.6rem',
      padding: '0 1rem 0 0',
      textAlign: 'left',
      width: '10rem', // '53.6rem',
      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        minWidth: '10rem', //'8.8rem', //'33.8rem',
        width: '10rem', //'8.8rem', //'33.8rem',
      },
    },
    textContainer: {
      fontSize: '1.2rem',
      height: '2.6rem',
    },

    input: {
      boxSizing: 'border-box',
      fontFamily: 'Manrope, sans-serif',
      fontSize: '1.2rem',
      minHeight: '2.6rem',
      lineHeight: '2.4rem',
      outline: 'none',
      overflow: 'hidden',
      resize: 'none',
      // whiteSpace: 'nowrap',
      width: '100%',
      '&[contenteditable="true"]': {
        border: `0.1rem solid ${variables.color.primary.lightGray}`,
        borderRadius: '0.6rem',
      },
      [`& ${PERSONALIZATION_TOKEN_TAG}`]: {
        backgroundColor: variables.colorV2.personalizationToken.background,
        borderRadius: '0.7rem',
        color: variables.colorV2.personalizationToken.text,
        padding: '0 1rem',
        pointerEvents: 'none',
      },
    },
    textEdit: {
      border: `0.1rem solid ${variables.color.primary.lightGray}`,
      borderRadius: '0.6rem',
      padding: '0 1.2rem 0 1.2rem',
    },
    textNoEdit: {
      border: `0.1rem solid transparent`,
      fontSize: '1.2rem',
      lineHeight: '2.4rem',
      minHeight: '2.6rem',
      padding: '0 1.2rem 0 1.2rem',
      width: '100%',
      '&:hover': {
        border: `0.1rem solid ${variables.color.primary.lightGray}`,
        borderRadius: '0.6rem',
        lineHeight: '2.4rem',
        padding: '0 1.2rem',
      },
    },
  }),
);
